import { clsx } from 'clsx'
import { forwardRef } from 'react'
import { ScrollView } from 'react-native'
import { KeyboardAwareScrollView, type KeyboardAwareScrollViewProps } from 'react-native-keyboard-controller'

import { VStack } from '@/components'

export interface ScreenScrollViewProps extends KeyboardAwareScrollViewProps {
  withBottomTabs?: boolean
  withCenterHorizontal?: boolean
  withCenterVertical?: boolean
  withFooter?: boolean
  withGap?: boolean
  withPadding?: boolean
}

export const ScreenScrollView = forwardRef<ScrollView, ScreenScrollViewProps>(
  (
    {
      children,
      contentContainerClassName,
      withBottomTabs,
      withCenterHorizontal,
      withCenterVertical,
      withFooter,
      withGap = true,
      withPadding = true,
      ...props
    },
    ref
  ) => (
    <KeyboardAwareScrollView
      bottomOffset={20}
      bounces={false}
      contentContainerClassName={clsx(
        'flex-grow', // ensure that content takes up all available space
        contentContainerClassName
      )}
      disableScrollOnKeyboardHide
      ref={ref}
      {...props}
    >
      <VStack
        className={clsx(
          'flex-1',
          withCenterHorizontal && 'items-center',
          withCenterVertical && 'justify-center',
          withGap && 'gap-4',
          withPadding && 'p-4'
        )}
      >
        {children}
      </VStack>
    </KeyboardAwareScrollView>
  )
)

ScreenScrollView.displayName = 'ScreenScrollView'
